import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CognitoRoleGuardService } from '@services/router-guards/cognito-role-guard.service';
import { PermissionCognitoGroups } from '@services/token';

import { RegistrationsComponent } from './registrations.component';

const routes: Routes = [
	{
		path: '',
		component: RegistrationsComponent,
		pathMatch: 'full',
		canActivate: [CognitoRoleGuardService],
		data: {
			cognitoRoles: [PermissionCognitoGroups.registrations]
		}
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class RegistrationsRoutingModule {}
